var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown-item',{attrs:{"to":_vm.to,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v("dropdown item")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }